"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AssetCollectionReleaseImpl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var coreHttp = _interopRequireWildcard(require("@azure/core-http"));

var Mappers = _interopRequireWildcard(require("../models/mappers"));

var Parameters = _interopRequireWildcard(require("../models/parameters"));

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

/** Class containing AssetCollectionRelease operations. */
var AssetCollectionReleaseImpl = /*#__PURE__*/function () {
  /**
   * Initialize a new instance of the class AssetCollectionRelease class.
   * @param client Reference to the service client
   */
  function AssetCollectionReleaseImpl(client) {
    (0, _classCallCheck2["default"])(this, AssetCollectionReleaseImpl);
    this.client = client;
  }
  /**
   *  (Auth: RhinestoneAuthorize[portalId, assetCollectionId])
   * @param portalId (Access Controlled)
   * @param assetCollectionId (Access Controlled)
   * @param releaseNumber
   * @param options The options parameters.
   */


  (0, _createClass2["default"])(AssetCollectionReleaseImpl, [{
    key: "getAssetCollectionRelease",
    value: function getAssetCollectionRelease(portalId, assetCollectionId, releaseNumber, options) {
      var operationArguments = {
        portalId: portalId,
        assetCollectionId: assetCollectionId,
        releaseNumber: releaseNumber,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getAssetCollectionReleaseOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[portalId, assetCollectionId])
     * @param portalId (Access Controlled)
     * @param assetCollectionId (Access Controlled)
     * @param options The options parameters.
     */

  }, {
    key: "getAssetCollectionReleasesList",
    value: function getAssetCollectionReleasesList(portalId, assetCollectionId, options) {
      var operationArguments = {
        portalId: portalId,
        assetCollectionId: assetCollectionId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getAssetCollectionReleasesListOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[portalId, assetCollectionId])
     * @param portalId (Access Controlled)
     * @param assetCollectionId (Access Controlled)
     * @param body
     * @param options The options parameters.
     */

  }, {
    key: "createAssetCollectionRelease",
    value: function createAssetCollectionRelease(portalId, assetCollectionId, body, options) {
      var operationArguments = {
        portalId: portalId,
        assetCollectionId: assetCollectionId,
        body: body,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, createAssetCollectionReleaseOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[portalId, assetCollectionId])
     * @param portalId (Access Controlled)
     * @param assetCollectionId (Access Controlled)
     * @param releaseNumber
     * @param artifactId
     * @param options The options parameters.
     */

  }, {
    key: "getAssetCollectionReleaseArtifactContent",
    value: function getAssetCollectionReleaseArtifactContent(portalId, assetCollectionId, releaseNumber, artifactId, options) {
      var operationArguments = {
        portalId: portalId,
        assetCollectionId: assetCollectionId,
        releaseNumber: releaseNumber,
        artifactId: artifactId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getAssetCollectionReleaseArtifactContentOperationSpec);
    }
  }]);
  return AssetCollectionReleaseImpl;
}(); // Operation Specifications


exports.AssetCollectionReleaseImpl = AssetCollectionReleaseImpl;
var serializer = new coreHttp.Serializer(Mappers,
/* isXml */
false);
var getAssetCollectionReleaseOperationSpec = {
  path: "/api/Portals({portalId})/AssetCollections({assetCollectionId})/Releases({releaseNumber})",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.AssetCollectionReleaseInfo
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.assetCollectionId, Parameters.releaseNumber],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var getAssetCollectionReleasesListOperationSpec = {
  path: "/api/Portals({portalId})/AssetCollections({assetCollectionId})/Releases",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "AssetCollectionReleaseInfo"
            }
          }
        }
      }
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.assetCollectionId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var createAssetCollectionReleaseOperationSpec = {
  path: "/api/Portals({portalId})/AssetCollections({assetCollectionId})/Releases",
  httpMethod: "POST",
  responses: {
    200: {
      bodyMapper: Mappers.AssetCollectionReleaseInfo
    },
    401: {},
    403: {}
  },
  requestBody: Parameters.body15,
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.assetCollectionId],
  headerParameters: [Parameters.accept, Parameters.contentType],
  mediaType: "json",
  serializer: serializer
};
var getAssetCollectionReleaseArtifactContentOperationSpec = {
  path: "/api/Portals({portalId})/AssetCollections({assetCollectionId})/Releases({releaseNumber})/Artifacts({artifactId})",
  httpMethod: "GET",
  responses: {
    200: {},
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.assetCollectionId, Parameters.releaseNumber, Parameters.artifactId],
  serializer: serializer
};